<div
  class="buttons-column ontario-column ontario-small-12 ontario-medium-12 ontario-large-12 ontario-padding-bottom-40-!">
  @if (showSuccess) {
    <app-success-banner [successMessage]="'Feedback.ThankYouForSubmitting' | translate"
      [successTitle]="'Feedback.FeedbackSubmitted' | translate">
    </app-success-banner>
  }
  <div id="feedback-container" class="ontario-padding-top-24-! ontario-margin-bottom-40-!">
    <h3>{{"Feedback.Feedback" | translate}}</h3>
    <div class="grey-box-body">
      <div class="icon-panel" [class.ontario-padding-bottom-16-!]="feedbackModel.feedbackStatusId == null">
        <div id="image-div" class="feedback-face-icons">
          <button class="face-icon" (click)="setupFeedbackType(feedbackStatusEnum.POSITIVE)"
            [ngClass]="feedbackModel.feedbackStatusId === feedbackStatusEnum.POSITIVE ? 'green-check' : 'green-face'"
            [attr.aria-pressed]="feedbackModel.feedbackStatusId === feedbackStatusEnum.POSITIVE ? true : false"
            [attr.aria-label]="(feedbackModel.feedbackStatusId === feedbackStatusEnum.POSITIVE ? 'Feedback.ClickedHappyAltText' : 'Feedback.HappyAltText') | translate">
          </button>
          <button class="face-icon" (click)="setupFeedbackType(feedbackStatusEnum.NEUTRAL)"
            [ngClass]="feedbackModel.feedbackStatusId === feedbackStatusEnum.NEUTRAL ? 'orange-check' : 'orange-face'"
            [attr.aria-pressed]="feedbackModel.feedbackStatusId === feedbackStatusEnum.NEUTRAL ? true : false"
            [attr.aria-label]="(feedbackModel.feedbackStatusId === feedbackStatusEnum.NEUTRAL ? 'Feedback.ClickedMehAltText' : 'Feedback.MehAltText') | translate">
          </button>
          <button class="face-icon" (click)="setupFeedbackType(feedbackStatusEnum.NEGATIVE)"
            [ngClass]="feedbackModel.feedbackStatusId === feedbackStatusEnum.NEGATIVE ? 'red-check' : 'red-face'"
            [attr.aria-pressed]="feedbackModel.feedbackStatusId === feedbackStatusEnum.NEGATIVE ? true : false"
            [attr.aria-label]="(feedbackModel.feedbackStatusId === feedbackStatusEnum.NEGATIVE ? 'Feedback.ClickedAngryAltText' : 'Feedback.AngryAltText') | translate">
          </button>
        </div>
        <div class="feedback-text">
          {{"Feedback.WeWouldLikeToHear" | translate}}
        </div>
      </div>

      @if (feedbackModel.feedbackStatusId != null) {
        <div id="feedback-content" class="ontario-row ontario-padding-bottom-32-!"
          >
          <div class="ontario-column ontario-small-12 ontario-large-5 participation-info ontario-padding-bottom-16-!">
            <h4>{{"Feedback.WeWantYourParticipation" | translate}}</h4>
            <p> {{"Feedback.ThankYouForUsingTheWorkplaceSafetyPlanBuilder" | translate}}</p>
            <h4>{{"Feedback.YourPrivacyMatters" | translate}}</h4>
            <p [innerHTML]='"Feedback.TheFeedbackYouProvide" | translate'></p>
            <p [innerHTML]='"Feedback.YourFeedbackWillBeMadeIntoAnonymousData" | translate'></p>
            <p [innerHTML]='"Feedback.IfYouDoProvideContact" | translate'></p>
            <h4>{{"Feedback.Accessibility" | translate}}</h4>
            <p [innerHTML]='"Feedback.WeAreCommittedToProvidingAccessibleCustomerService" | translate'></p>
          </div>
          <div class="feedback-form-controls ontario-column ontario-small-12 ontario-large-7">
            <div class="ontario-column ontario-small-12 ontario-large-5">
              <app-dropdown [currentLang]="currentLang" [label]="'Feedback.FeedbackAbout' | translate"
              [options]="feedbackOptionValues"></app-dropdown>
            </div>
            <div class="ontario-column ontario-small-12 ontario-large-7">
              <label class="input-label" for="serviceName">{{"Feedback.NameOfService" | translate}}</label>
              <input type="text" class='input-text' id="serviceName" [(ngModel)]="feedbackModel.serviceName">
            </div>
            <div
              class="ontario-column ontario-small-12 input-div ontario-margin-top-8-! not-table-cell ontario-padding-bottom-24-!">
              <label class="input-label" for="feedback-message">{{"Feedback.FeedbackMessage" | translate}}</label>
              <textarea [placeholder]="'Feedback.FeedbackPlaceholder' | translate" id="feedback-message"
              [(ngModel)]="feedbackModel.feedbackContent" rows="8"></textarea>
            </div>
            <div class="ontario-column ontario-margin-top-24-! ontario-padding-bottom-12-!">
              <div class="ontario-checkboxes__item">
                <input type="checkbox" [(ngModel)]="feedbackModel.isParticipatingInResearch" id="research" class="ontario-checkboxes__input" (keyup)="researchKeyUp($event)">
                <label class="ontario-checkboxes__label" for="research"
                [innerHtml]="('Feedback.IAmInterestedInParticipating' | translate)"></label>
              </div>
              <div class="ontario-checkboxes__item">
                <input type="checkbox" [(ngModel)]="feedbackModel.isReplyExpected" id="replyExpected" class="ontario-checkboxes__input" (keyup)="replyExpectedKeyUp($event)"  >
                <label class="ontario-checkboxes__label" for="replyExpected">{{"Feedback.DoYouExpectReplyFromMinistry" | translate}}</label>
              </div>
            </div>
            <div class="ontario-column ontario-margin-top-24-! ontario-padding-bottom-12-! email-input">
              <label for="email">{{"Contact.EmailAddress" | translate}}
                @if (!feedbackModel.isParticipatingInResearch) {
                  <span class="optional ">
                    ({{"Optional" | translate}})
                  </span>
                }
              </label>
              <input autocomplete="email" type="email" class='input-text' id="email" [(ngModel)]="feedbackModel.email">
            </div>
            <div class="button-row ontario-column bottom-buttons ontario-small-12">
              <button id="submit-button" class="ontario-button--primary ontario-button" (click)="submitFeedback()">{{"Feedback.SubmitFeedback" | translate}}</button>
              <button id="cancel-button" class="manage-button ontario-button ontario-button--tertiary"
              (click)="resetFeedback()">{{"General.Cancel" | translate}}</button>
            </div>
          </div>
        </div>
      }

    </div>
  </div>
</div>
